import { RegExPattern } from '../models/regexp-pattern/regex-pattern';

/**
 * Mask configurations used in the [mask] directive.
 * Documentation: https://imask.js.org/guide.html
 */
export class IMaskConstants {
    /**
     * Applies a US and Canada postal code mask.
     */
    public static readonly postalCode = {
        mask: [
            {
                mask: 'a0a 0a0',
                definitions: {
                    a: /[A-Za-z]/,
                },
            },
            { mask: '00000' },
            { mask: '00000-0000' },
        ],
        lazy: false,
        // Uppercases all letters (on input) to ensure Canadian postal codes follow the expected uppercased format.
        prepare: (value: string) => value.toUpperCase(),
    };

    public static readonly callSign = {
        mask: new RegExp(RegExPattern.CallSign),
        prepare: (value: string) => value.toUpperCase(),
    };

    public static readonly scheduleHAssociatedCallSign = {
        mask: new RegExp(RegExPattern.ScheduleHAssociatedCallSign),
        prepare: (value: string) => value.toUpperCase(),
    };

    /**
     * Applies a mask to uppercase all letters.
     */
    public static readonly uppercase = {
        mask: new RegExp(RegExPattern.MatchAnyStringIncludingEmpty),
        prepare: (value: string) => value.toUpperCase(),
    };

    public static readonly positiveIntegers = {
        mask: Number,
        min: 0,
        max: 999999999, // A reasonably high number that stays under SQL int max (~2.1B)
        scale: 0,
    };

    /**
     * Applies a credit card number mask with dashes.
     * Visa / Mastercard: 1234-5678-9012-3456 (4-4-4-4)
     * AMEX:              1234-123456-01234   (4-6-5)
     */
    public static readonly creditCard = {
        mask: [
            { mask: '0000-000000-00000' }, // AMEX (4-6-5)
            { mask: '0000-0000-0000-0000' }, // Visa / Mastercard (4-4-4-4)
        ],
    };
}
